/**
 * pushStageNavigation
 * ───────────────────
 * Maps a PushProgressTracker stage key → the PushNextStep that should
 * fire when an operator clicks that stage. Modal-when-possible; falls
 * back to navigation for the 4 stages without a Push modal
 * (Review, QA, Closeout, Invoice).
 *
 * This keeps tracker click behavior consistent across every Push modal
 * (Ordering, Reschedule, Quick Assign, Permit, Resolve Issue) and
 * routes through the existing `onChooseNextStep → usePushChain.chainTo`
 * channel — so parents need zero new wiring.
 */
import type { PushNextStep } from "@/components/quick-actions/PushNextStepPanel";

export type TrackerStageKey =
  | "review"
  | "permit"
  | "materials"
  | "crew"
  | "schedule"
  | "qa"
  | "closeout"
  | "invoice";

export function stageKeyToPushStep(
  key: TrackerStageKey,
  jobId: string,
): PushNextStep {
  switch (key) {
    case "review":
      return { kind: "navigate", to: `/intake-review?jobId=${jobId}` };
    case "permit":
      return { kind: "view_permit" };
    case "materials":
      return { kind: "generate_po" };
    case "crew":
      return { kind: "assign_crew" };
    case "schedule":
      return { kind: "reschedule" };
    case "qa":
      return { kind: "navigate", to: `/qa-form?jobId=${jobId}` };
    case "closeout":
      return { kind: "navigate", to: `/closeout?jobId=${jobId}` };
    case "invoice":
      return { kind: "navigate", to: `/accounting?jobId=${jobId}` };
  }
}
